var _rect, _rect2, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgRangePickerArrow = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.22186,
    y: 0.715997,
    width: 10.5565,
    height: 11.1339,
    rx: 5.27823,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.22186,
    y: 0.715997,
    width: 10.5565,
    height: 11.1339,
    rx: 5.27823,
    stroke: "#DFE3E9",
    strokeWidth: 0.795276
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48242 6.28282L3.51786 6.28282M9.48242 6.28282L6.92618 8.51953M9.48242 6.28282L6.92618 4.04611",
    stroke: "#A8AAB7",
    strokeWidth: 0.596457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRangePickerArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RangePickerArrow.0a60a820.svg";
export { ForwardRef as ReactComponent };